import React, { useState, useEffect } from 'react';
import Editor from 'react-simple-code-editor';
import axios from 'axios';
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext';
import { isLocalHost } from '../../shared/host_utils.js';

// Hàm lấy main domain
export const getMainDomain = () => {
    const hostname = window.location.hostname;
    if (isLocalHost(hostname)) return 'hust';
    const parts = hostname.split('.');
    // Nếu có nhiều hơn 2 phần, lấy phần thứ hai từ cuối, ngược lại lấy phần đầu tiên
    return parts.length > 2 ? parts[parts.length - 2] : parts[0];
};
function hasIdField(obj) {
    return Object.prototype.hasOwnProperty.call(obj, 'id');
}

function MyJsonEditor() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let query = urlParams.get('query');
    const isPortCli = query === 'port_cli';
    const portCliApi = 'https://nginx.hust.media/go/servers/port_cli/show';

    const initialJSON = {
        id: 1,
        title: "đợi xíu nhé"
    };
    const insert_json_note = {
        note: "Ko nhập id để tự thêm",
        json: "..."
    };
    // alert(query);
    // Lưu JSON dưới dạng chuỗi (cho editor) và dạng object (cho hiển thị)
    const [code, set_code] = useState(JSON.stringify(initialJSON, null, 2));
    const [code_insert, set_code_insert] = useState(JSON.stringify(insert_json_note, null, 2));
    const [currentJson, setCurrentJson] = useState(initialJSON);
    const [error, setError] = useState("");
    const [show_insert, set_show_insert] = useState(false);

    const process_params = async (query) => {
        const urlParams = new URLSearchParams(window.location.search);
        let main_domain = urlParams.get('main_domain');
        if (main_domain) {
            main_domain = getMainDomain() || "hust";
            query = `${query}.${main_domain}`;
            lay_json(query);
        } else {
            lay_json(query);
        }
    };
    // Hàm tô màu tự viết (không dùng thư viện nào thêm)
    const highlightCode = (codeString) => {
        if (!codeString) return '';
        codeString = codeString
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        return codeString.replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
            (match) => {
                let color = 'darkorange';
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        color = 'red';
                    } else {
                        color = 'green';
                    }
                } else if (/true|false/.test(match)) {
                    color = 'blue';
                } else if (/null/.test(match)) {
                    color = 'magenta';
                }
                return `<span style="color: ${color};">${match}</span>`;
            }
        );
    };

    // Nút "Xác nhận": Parse JSON từ editor và cập nhật JSON hiện tại nếu hợp lệ
    const handleConfirm = () => {
        if (isPortCli) {
            alert_error("port_cli hiện chỉ hỗ trợ xem JSON");
            return;
        }

        try {
            const json_edit = JSON.parse(code);
            setError("");
            // const json_edit = (JSON.stringify(parsed, null, 2));
            if (show_insert) {
                insert_data(json_edit);
            } else {
                edit_data(json_edit);
            }
        } catch (err) {
            alert_error("JSON không hợp lệ");
            setError("JSON không hợp lệ");
        }
    };
    const edit_data = (json_edit) => {
        setCurrentJson(json_edit);
        const data = JSON.stringify({
            query: { [query]: { $exists: true } },
            set: { [query]: json_edit }
        });
        const url = 'https://node_js.hust.media/main_1/mongo_1/api/mongo_update_single_api';
        api_edit(data, url);
    };
    const insert_data = (json_edit) => {
        if (hasIdField(json_edit)) { alert_error("lỗi có trường id"); }
        else {
            const data = JSON.stringify({
                query: query,
                set: json_edit
            });
            const url = 'https://node_js.hust.media/main_1/mongo_1/api/mongo_insert_id';
            api_edit(data, url);
        }
    };
    const api_edit = (data, url) => {
        console.log(data);
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: { 'Content-Type': 'application/json' },
            data: data
        };
        axios.request(config)
            .then(response => {
                alert_success("Sửa JSON thành công");
                setCurrentJson(initialJSON);
                process_params(query);
            })
            .catch(error => {
                console.log(error);
                alert_error("Sửa JSON thất bại");
            });
    };
    // Nút "Format": Định dạng lại JSON trong editor
    const handleFormat = () => {
        try {
            const parsed = JSON.parse(code);
            const formatted = JSON.stringify(parsed, null, 2);
            set_code(formatted);
            setError("");
        } catch (err) {
            alert_error("JSON không hợp lệ");
            setError("JSON không hợp lệ");
        }
    };

    // Hàm "Lấy JSON": Gọi API lấy JSON và cập nhật cho editor và bảng hiển thị
    const lay_json = (query) => {
        if (query === 'port_cli') {
            axios
                .get(portCliApi)
                .then(response => {
                    const newJson = response.data?.api_results?.mongo_results ?? response.data;
                    setCurrentJson(newJson);
                    set_code(JSON.stringify(newJson, null, 2));
                    alert_success("Lấy port_cli JSON thành công");
                })
                .catch(error => {
                    console.log(error);
                    alert_error("Lấy port_cli JSON thất bại");
                });
            return;
        }

        // alert(query);
        const data = JSON.stringify({
            query: query
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://node_js.hust.media/main_1/mongo_1/api/mongo_get_query_api',
            headers: { 'Content-Type': 'application/json' },
            data: data
        };

        axios.request(config)
            .then(response => {
                // Giả sử JSON trả về ở response.data.api_results.mongo_results
                const newJson = response.data.api_results.mongo_results;
                setCurrentJson(newJson);
                set_code(JSON.stringify(newJson, null, 2));
                alert_success("Lấy JSON thành công");
            })
            .catch(error => {
                console.log(error);
                alert_error("Lấy JSON thất bại");
            });
    };
    // Hàm "Lấy JSON": Gọi API lấy JSON và cập nhật cho editor và bảng hiển thị
    const them_json = () => {
        if (isPortCli) {
            alert_error("port_cli hiện chỉ hỗ trợ xem JSON");
            return;
        }

        // alert(query);
        set_show_insert(!show_insert);
        if (show_insert) {
            set_code(JSON.stringify(currentJson, null, 2));
        } else {
            set_code(JSON.stringify(insert_json_note, null, 2));
        }
    };
    // Gọi API tự động khi component mount
    useEffect(() => {
        if (query) {
            process_params(query);
        };
    }, [query]);

    return (
        <div className="max-w-5xl mx-auto p-4 border rounded space-y-4">
            {/* Header với tiêu đề và 2 nút */}
            <div className="flex flex-col md:flex-row items-center justify-between">
                <h2 className="text-2xl font-bold">JSON Editor</h2>
                <div className="flex space-x-2 mt-2 md:mt-0">
                    <button
                        onClick={them_json}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                    >
                        {show_insert ? 'Chỉnh sửa JSON' : 'Thêm JSON'}
                    </button>

                    <button
                        onClick={handleConfirm}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                    >
                        Xác nhận.
                    </button>
                    <button
                        onClick={handleFormat}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                    >
                        Format
                    </button>
                </div>
            </div>
            {/* Nội dung chính: 2 cột responsive */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Hiển thị JSON hiện tại với highlight */}
                <div>
                    <h3 className="text-xl font-semibold mb-1">JSON hiện tại</h3>
                    <pre
                        className="bg-gray-100 p-3 border rounded overflow-auto font-mono"
                        style={{ minHeight: '250px' }}
                        dangerouslySetInnerHTML={{ __html: highlightCode(JSON.stringify(currentJson, null, 2)) }}
                    />
                </div>

                {/* Editor chỉnh sửa JSON */}
                <div>
                    <div>
                        <h3 className="text-xl font-semibold mb-1">
                            {show_insert ? 'INSERT JSON' : 'Chỉnh sửa JSON'}
                        </h3>
                    </div>
                    <Editor
                        value={code}
                        onValueChange={set_code}
                        highlight={highlightCode}
                        padding={8}
                        style={{
                            fontFamily: 'monospace',
                            fontSize: 14,
                            border: '1px solid #ccc',
                            borderRadius: 4,
                            minHeight: '250px',
                            backgroundColor: '#f5f5f5'
                        }}
                    />
                    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                </div>
            </div>
        </div>
    );
}

export default MyJsonEditor;
